
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 19V7.83l4.88 4.88a1 1 0 101.42-1.41l-6.59-6.59a1 1 0 00-1.41 0l-6.6 6.58a1 1 0 101.41 1.41L11 7.83V19a1 1 0 002 0z"}})])
          )
        }
      }
    